<div class="zk-flex zk-flex-col">
	<div class="zk-flex zk-flex-row zk-items-center zk-gap-2">
		<p 
			(keyup)="$event.key === 'Enter' ? openContactDetails('name') : null"
			(click)="openContactDetails('name')" 
			freud-typography 
			fontType="h3BoldAuto" 
			class="appointment-details-title"
		>
			{{ event.userName }}
	   </p>
	   <freud-tag 
			*ngIf="isFirstSession"
			[value]="'APPOINTMENTS.DETAILS.HEADER.FIRST_SESSION' | translate"
		></freud-tag>
		<div 
			class="icon-wrapper" 
			(keyup)="$event.key === 'Enter' ? openContactDetails('icon') : null"
			(click)="openContactDetails('icon')"
			freud-tooltip
			[tooltipLabel]="'APPOINTMENTS.DETAILS.HEADER.PROFILE_TOOLTIP' | translate"
			tooltipPosition="bottom" 
		>
			<freud-icon icon="user"></freud-icon>
		</div>
	</div>
	<details-contact-info
		*ngIf="contact"
		[contact]="contact"
		[payment]="event.paymentMethod"
	></details-contact-info>
</div>


